import axios from'../axios';var ekycService={};export default ekycService;